export const PRINTFUL_STORES_FIELDS_LIST: any = [
    {attribute: "id", label: "ID", cssClass: ''},
    {attribute: "name", label: "Name", cssClass: ''},
];


export const PRINTFUL_STORES_INPUT_FIELDS: any = [
    {attribute: "id", label: "ID", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
];
